import type { ArticleMeta } from "@/types/article";

export const articleMeta: ArticleMeta[] = [
  {
    slug: "what-is-usfans-spreadsheet",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20a%20clean%20spreadsheet%20with%20product%20categories%20on%20a%20soft%20minimal%20desk%2C%20fresh%20airy%20editorial%20style%2C%20soft%20natural%20light%2C%20sage%20green%20accents%2C%20high%20detail&width=800&height=600&seq=article-01&orientation=landscape",
  },
  {
    slug: "usfans-spreadsheet-guide",
    image:
      "https://readdy.ai/api/search-image?query=Organized%20binder%20with%20printed%20spreadsheet%20tabs%20and%20color%20coded%20sections%20on%20a%20warm%20amber%20desk%2C%20clean%20editorial%20style%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=article-02&orientation=landscape",
  },
  {
    slug: "usfans-spreadsheet-for-beginners",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20beginner%20workspace%20with%20notebook%20coffee%20and%20a%20tablet%20showing%20a%20simple%20checklist%20on%20a%20soft%20mint%20background%2C%20fresh%20editorial%20style%2C%20high%20detail&width=800&height=600&seq=article-03&orientation=landscape",
  },
  {
    slug: "usfans-review",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20review%20rating%20cards%20with%20stars%20and%20notes%20spread%20on%20a%20soft%20coral%20pastel%20surface%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=article-04&orientation=landscape",
  },
  {
    slug: "usfans-shipping-cost",
    image:
      "https://readdy.ai/api/search-image?query=Neat%20stack%20of%20kraft%20shipping%20boxes%20with%20packing%20tape%20and%20a%20tape%20measure%20on%20a%20soft%20sand%20beige%20background%2C%20minimal%20editorial%20style%2C%20high%20detail&width=800&height=600&seq=article-05&orientation=landscape",
  },
  {
    slug: "usfans-coupon",
    image:
      "https://readdy.ai/api/search-image?query=Colorful%20discount%20coupon%20tickets%20and%20scissors%20on%20a%20soft%20lemon%20yellow%20background%2C%20minimal%20flat%20lay%20editorial%20style%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=article-06&orientation=landscape",
  },
  {
    slug: "usfans-discount-code",
    image:
      "https://readdy.ai/api/search-image?query=Price%20tags%20and%20a%20smartphone%20with%20a%20promo%20code%20screen%20on%20a%20soft%20blush%20pink%20background%2C%20minimal%20editorial%20style%2C%20soft%20light%2C%20high%20detail&width=800&height=600&seq=article-07&orientation=landscape",
  },
  {
    slug: "usfans-warehouse",
    image:
      "https://readdy.ai/api/search-image?query=Tidy%20warehouse%20shelves%20with%20labeled%20cardboard%20boxes%20on%20a%20soft%20teal%20tinted%20scene%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=article-08&orientation=landscape",
  },
  {
    slug: "is-usfans-legit",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20trust%20and%20shield%20symbol%20with%20checkmark%20badges%20on%20a%20soft%20sage%20green%20background%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=article-09&orientation=landscape",
  },
  {
    slug: "usfans-safety-guide",
    image:
      "https://readdy.ai/api/search-image?query=Simple%20safety%20checklist%20on%20a%20clipboard%20with%20a%20pen%20on%20a%20soft%20warm%20grey%20background%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=article-10&orientation=landscape",
  },
  {
    slug: "usfans-comparison",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20split%20comparison%20layout%20with%20two%20columns%20and%20product%20photos%20on%20a%20soft%20terracotta%20background%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=article-11&orientation=landscape",
  },
];